import { React } from "react";
import { useTranslation } from "react-i18next";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import Zones from "../components/Zone";
import MaritalStautus from "../components/MaritalStauts";
import NumberOfDependants from "../components/NumberOfDependants";
import Nationality from "../components/Nationality";
import { CurrentLocation } from "../components/CurrentLocation";
import BirthDate from "../components/BirthDate";
import NeedDocumentation from "../components/NeedDocumentation";
import NameOrEmail from "../components/NameOrEmail";
import GitHub from "../components/GitHub";
import LinkedIn from "../components/LinkedIn";
import MobileNumber from "../components/MobileNumber";
import { ValidateFields } from "../ValidateFields";
import { Row } from "react-bootstrap";

export function PersonalInformation({ changeCardStatus, cardStatus }) {
  const { t } = useTranslation();
  const { searchObject, setSearchObject, onChange } = useAdvanceSearchContext();

  function clearPersonalInformation() {
    searchObject.nameOrEmail = undefined;
    searchObject.mobileNumber = undefined;
    searchObject.zones = [];
    searchObject.maritalStatusId = undefined;
    searchObject.numberOfDependantId = undefined;
    searchObject.nationalityId = undefined;
    searchObject.countryId = undefined;
    searchObject.cityId = undefined;
    searchObject.birthDateEnd = undefined;
    searchObject.birthDateStart = undefined;
    searchObject.needDocumentation = undefined;
    searchObject.linkedIn = undefined;
    searchObject.gitHub = undefined;

    setSearchObject({
      ...searchObject
    });
  }

  return (
    <>
      <div className="accordion-item border-accordion">
        <h2
          className="accordion-header margin-accordion"
          id="headingCompetence"
        >
          <button
            className={`accordion-button border-accordion-button ${
              cardStatus ? "" : "collapsed heding-bold"
            }`}
            type="button"
            data-bs-target="#collapseCvs"
            aria-expanded="true"
            aria-controls="collapseCvs"
            onClick={changeCardStatus}
            id="accordionPersonalInformation"
          >
            {`${t("Personal Information")} ${ValidateFields.personal(
              searchObject
            )}`}
          </button>
        </h2>
        <div
          id="accordionInputs"
          className={`accordion-collapse ${cardStatus ? "" : "collapse"}`}
          aria-labelledby="headingCompetence"
          data-bs-parent="#accordionFlushDocuments"
        >
          <div className="accordion-body table-wrap ">
            <Row>
              <div className="col-md-6">
                <NameOrEmail
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-4">
                <MobileNumber
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-6">
                <Zones
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-3">
                <MaritalStautus
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-3">
                <NumberOfDependants
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-6">
                <CurrentLocation
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-3">
                <BirthDate
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-3">
                <Nationality
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-3">
                <NeedDocumentation
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-6">
                <LinkedIn
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-6">
                <GitHub searchObject={searchObject} onChange={onChange} t={t} />
              </div>
            </Row>
          </div>
          <div className="text-end button-clear-position">
            <button
              className="app-button btn-second btn-md"
              onClick={clearPersonalInformation}
            >
              {t("Clear Personal Information")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
